import { render, staticRenderFns } from "./service-panel.vue?vue&type=template&id=df372352"
import script from "./service-panel.vue?vue&type=script&lang=js"
export * from "./service-panel.vue?vue&type=script&lang=js"
import style0 from "./service-panel.vue?vue&type=style&index=0&id=df372352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports